import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BusinessHero } from '@/components/ui/content-blocks';
import { useTranslation } from '@/hooks/useTranslation';

const HeaderSection = () => {
  const { t } = useTranslation();
  
  return (
    <BusinessHero
      title={t('erpPage.header.title')}
      titleHighlight={t('erpPage.header.titleHighlight')}
      description={t('erpPage.header.description')}
      details={t('erpPage.header.details')}
      backgroundStyle="blue"
      primaryCTA={{
        label: t('erpPage.header.primaryCTA'),
        href: "#erp-features"
      }}
      secondaryCTA={{
        label: t('erpPage.header.secondaryCTA'),
        href: "#contact",
        icon: <ArrowRight size={16} />
      }}
    />
  );
};

export default HeaderSection; 